const DIRECT_FILE_PREVIEW_RESOURCE_TYPES = [7, 8, 9]
const DIRECT_FILE_PREVIEW_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp']
const DIRECT_FILE_PREVIEW_FILE_PATH_KEYS = ['filePath', 'filepath', 'file_path', 'fileUrl', 'file_url', 'downloadUrl', 'download_url']
const DIRECT_FILE_PREVIEW_PREVIEW_PATH_KEYS = ['resourceUrl', 'resource_url', 'pdfPreviewUrl', 'pdf_preview_url']
const DIRECT_FILE_PREVIEW_PATH_KEYS = ['path']
const DIRECT_FILE_PREVIEW_GENERIC_PATH_KEYS = ['url', 'src']
const DIRECT_FILE_PREVIEW_NESTED_KEYS = ['raw', 'resource', 'detail', 'data', 'result', 'payload', 'body', 'source', 'original', 'paperMeeting', 'paper_meeting']
const COMPACT_COUNT_UNIT_LANGUAGES = ['zh', 'tw', 'ja', 'ko']

export default {
  methods: {
    isDirectFilePreviewResourceType(resourceType) {
      const value = Number(resourceType)
      return Number.isFinite(value) && DIRECT_FILE_PREVIEW_RESOURCE_TYPES.includes(value)
    },
    isDirectFilePreviewNumericResourceType(resourceType) {
      if (resourceType === undefined || resourceType === null || resourceType === '' || typeof resourceType == 'boolean') {
        return false
      }
      return Number.isFinite(Number(resourceType))
    },
    isDirectFilePreviewItem(item) {
      if (!item || typeof item != 'object') {
        return false
      }
      const resourceType = this.getDirectFilePreviewResourceType(item)
      return !!(this.isDirectFilePreviewResourceType(resourceType) && this.pickDirectFilePreviewPath(item))
    },
    isDirectFilePreviewDetail(detail) {
      if (!detail || typeof detail != 'object' || !detail.isDirectFilePreview) {
        return false
      }
      const resourceType = this.getDirectFilePreviewResourceType(detail)
      return !!(this.isDirectFilePreviewResourceType(resourceType) && this.pickDirectFilePreviewPath(detail))
    },
    isDirectFilePreviewPdfDetail(detail) {
      return !!(this.isDirectFilePreviewDetail(detail) && Number(this.getDirectFilePreviewResourceType(detail)) === 7)
    },
    getDirectFilePreviewSource(detail) {
      return this.pickDirectFilePreviewPath(detail)
    },
    createDirectFilePreviewPdfDetail(detail, previewUrl) {
      const sourceUrl = String(previewUrl || this.getDirectFilePreviewSource(detail) || '').trim()
      if (!sourceUrl) {
        return null
      }
      return Object.assign({}, detail, {
        resourceUrl: sourceUrl,
        pdfPreviewUrl: sourceUrl,
        imagePages: [{
          pageNo: 1,
          imageUrl: '',
          pdfPreviewUrl: sourceUrl,
          isPdfPreview: true
        }]
      })
    },
    isDirectFilePreviewMetaEmpty(meta) {
      if (meta === undefined || meta === null) {
        return true
      }
      if (typeof meta == 'string') {
        const text = meta.trim()
        if (!text || text == '{}' || text == '[]' || text == 'null') {
          return true
        }
        try {
          const parsed = JSON.parse(text)
          if (parsed !== text) {
            return this.isDirectFilePreviewMetaEmpty(parsed)
          }
        } catch (error) {
          return false
        }
        return false
      }
      if (Array.isArray(meta)) {
        return meta.length == 0
      }
      if (typeof meta == 'object') {
        return Object.keys(meta).length == 0
      }
      return true
    },
    getDirectFilePreviewResourceType(item) {
      const sources = this.getDirectFilePreviewSourceChain(item)
      if (sources.length == 0) {
        return undefined
      }
      const root = sources[0]
      const rootResourceType = this.pickDirectFilePreviewValue(root, ['resourceType', 'resource_type', 'resrouceType', 'resrouce_type'])
      let fallback
      if (rootResourceType !== undefined && this.isDirectFilePreviewNumericResourceType(rootResourceType)) {
        return rootResourceType
      }
      if (rootResourceType !== undefined) {
        fallback = rootResourceType
      }
      const rootType = this.pickDirectFilePreviewValue(root, ['type'])
      if (rootType !== undefined && this.isDirectFilePreviewNumericResourceType(rootType)) {
        return rootType
      }
      if (rootType !== undefined && fallback === undefined) {
        fallback = rootType
      }
      for (let i = 1; i < sources.length; i += 1) {
        const resourceType = this.pickDirectFilePreviewValue(sources[i], ['resourceType', 'resource_type', 'resrouceType', 'resrouce_type'])
        if (resourceType !== undefined && this.isDirectFilePreviewNumericResourceType(resourceType)) {
          return resourceType
        }
        if (resourceType !== undefined && fallback === undefined) {
          fallback = resourceType
        }
      }
      for (let i = 1; i < sources.length; i += 1) {
        const type = this.pickDirectFilePreviewValue(sources[i], ['type'])
        if (type !== undefined && this.isDirectFilePreviewNumericResourceType(type)) {
          return type
        }
        if (type !== undefined && fallback === undefined) {
          fallback = type
        }
      }
      return fallback
    },
    getDirectFilePreviewSourceChain(item) {
      const sources = []
      const visited = []
      const visit = (source, depth) => {
        if (!source || typeof source != 'object' || Array.isArray(source) || depth > 4 || visited.includes(source)) {
          return
        }
        visited.push(source)
        sources.push(source)
        DIRECT_FILE_PREVIEW_NESTED_KEYS.forEach(key => {
          if (source[key] && typeof source[key] == 'object') {
            visit(source[key], depth + 1)
          }
        })
      }
      visit(item, 0)
      return sources
    },
    getDirectFilePreviewMetaCandidates(payload, options = {}) {
      const candidates = []
      const visited = []
      const visit = source => {
        if (!source || typeof source != 'object' || Array.isArray(source) || visited.includes(source)) {
          return
        }
        visited.push(source)
        const nestedKeys = DIRECT_FILE_PREVIEW_NESTED_KEYS.filter(key => key != 'raw')
        if (options.preferEmpty) {
          candidates.push(source)
          nestedKeys.forEach(key => visit(source[key]))
        } else {
          nestedKeys.forEach(key => visit(source[key]))
          candidates.push(source)
        }
      }
      visit(payload)
      return candidates
    },
    resolveDirectFilePreviewMeta(payload, options = {}) {
      const candidates = this.getDirectFilePreviewMetaCandidates(payload, options)
      let parsedFallback = {}
      for (let i = 0; i < candidates.length; i += 1) {
        const found = this.getDirectFilePreviewOwnValue(candidates[i], ['meta'])
        if (!found.found) {
          continue
        }
        let parsedMeta = found.value
        try {
          parsedMeta = typeof this.parseMeta == 'function' ? this.parseMeta(found.value) : found.value
        } catch (error) {
          parsedMeta = {}
        }
        if (options.preferEmpty || !this.isDirectFilePreviewMetaEmpty(parsedMeta)) {
          return parsedMeta
        }
        parsedFallback = parsedMeta
      }
      return parsedFallback
    },
    async resolveDirectFilePreviewMetaAsync(payload, options = {}) {
      const candidates = this.getDirectFilePreviewMetaCandidates(payload, options)
      let parsedFallback = {}
      for (let i = 0; i < candidates.length; i += 1) {
        const found = this.getDirectFilePreviewOwnValue(candidates[i], ['meta'])
        if (!found.found) {
          continue
        }
        let parsedMeta = found.value
        try {
          parsedMeta = typeof this.parseMetaAsync == 'function'
            ? await this.parseMetaAsync(found.value, true)
            : (typeof this.parseMeta == 'function' ? this.parseMeta(found.value) : found.value)
        } catch (error) {
          parsedMeta = {}
        }
        if (options.preferEmpty || !this.isDirectFilePreviewMetaEmpty(parsedMeta)) {
          return parsedMeta
        }
        parsedFallback = parsedMeta
      }
      return parsedFallback
    },
    resolveDirectFilePreviewApiPayload(ret) {
      const hasOwn = (source, key) => !!(source && typeof source == 'object' && Object.prototype.hasOwnProperty.call(source, key))
      const hasDetailFields = source => {
        if (!source || typeof source != 'object' || Array.isArray(source)) {
          return false
        }
        return [
          'meta',
          'resource',
          'paperMeeting',
          'paper_meeting',
          'imagePages',
          'image_pages',
          'annotations',
          'filePath',
          'filepath',
          'file_path',
          'resourceType',
          'resource_type',
          'resrouceType',
          'resrouce_type',
          'fileUrl',
          'file_url',
          'resourceUrl',
          'resource_url',
          'detail'
        ].some(key => hasOwn(source, key)) || this.isDirectFilePreviewItem(source)
      }
      let data = ret
      if (
        hasOwn(data, 'data')
        && !hasOwn(data, 'code')
        && !hasOwn(data, 'success')
        && !hasDetailFields(data)
      ) {
        data = data.data
      }
      for (let depth = 0; depth < 6; depth += 1) {
        if (data === undefined || data === null) {
          return null
        }
        if (Array.isArray(data)) {
          return data
        }
        if (typeof data != 'object') {
          return data
        }
        const code = this.pickDirectFilePreviewValue(data, ['code', 'statusCode'])
        const hasCode = code !== undefined && code !== null && code !== ''
        if (hasCode && code != 200 && code != '200') {
          return data
        }
        if (code == 200 || code == '200') {
          if (hasOwn(data, 'data')) {
            if (data.data === undefined || data.data === null) {
              return hasDetailFields(data) ? data : {}
            }
            data = data.data
            continue
          }
          return hasDetailFields(data) ? data : {}
        }
        if (data.success === true) {
          if (hasOwn(data, 'data')) {
            if (data.data === undefined || data.data === null) {
              return hasDetailFields(data) ? data : {}
            }
            data = data.data
            continue
          }
          return hasDetailFields(data) ? data : {}
        }
        if (hasDetailFields(data)) {
          return data
        }
        if (hasOwn(data, 'data')) {
          data = data.data
          continue
        }
        return null
      }
      return null
    },
    isDirectFilePreviewAuthFailure(source) {
      const response = source && source.response ? source.response : source
      const status = response && response.status
      if (status == 401 || status == 403) {
        return true
      }
      const responseData = response && response.data && typeof response.data == 'object' ? response.data : response
      const code = this.pickDirectFilePreviewValue(responseData, ['code', 'statusCode'])
      if (code == 401 || code == '401' || code == 403 || code == '403' || code == 10104 || code == '10104' || code == 10013 || code == '10013') {
        return true
      }
      const message = this.pickDirectFilePreviewString(responseData, ['msg', 'message', 'errorMessage', 'error'])
      return /(unauthori[sz]ed|forbidden|permission|access\s*denied|password|授权|权限|密码)/i.test(message)
    },
    canFallbackDirectFilePreview(item, source, password = '') {
      if (!this.isDirectFilePreviewItem(item)) {
        return false
      }
      if (password && this.isDirectFilePreviewAuthFailure(source)) {
        return false
      }
      return !this.isDirectFilePreviewAuthFailure(source)
    },
    getDirectFilePreviewFallbackItem(item) {
      if (!item || typeof item != 'object') {
        return null
      }
      const resourceType = this.getDirectFilePreviewResourceType(item)
      const filePath = this.pickDirectFilePreviewPath(item)
      if (!this.isDirectFilePreviewResourceType(resourceType) || !filePath) {
        return null
      }
      const raw = item.raw && typeof item.raw == 'object' ? item.raw : null
      if (!raw) {
        return Object.assign({}, item, { filePath, resourceType })
      }
      return Object.assign({}, raw, item, { filePath, resourceType })
    },
    createDirectFilePreviewFallbackDetail(item, meta) {
      if (!this.isDirectFilePreviewMetaEmpty(meta)) {
        return null
      }
      const fallbackItem = this.getDirectFilePreviewFallbackItem(item)
      return fallbackItem ? this.createDirectFilePreviewDetail(fallbackItem) : null
    },
    createDirectFilePreviewDetail(item) {
      if (!this.isDirectFilePreviewItem(item)) {
        return null
      }
      const filePath = this.pickDirectFilePreviewPath(item)
      const previewUrl = this.toDirectFilePreviewUrl(filePath)
      if (!previewUrl) {
        return null
      }
      const extension = this.getDirectFilePreviewExtension(filePath)
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : null
      const name = this.pickDirectFilePreviewString(item, ['name', 'title', 'fileName', 'filename', 'resourceName', 'paperName', 'bookName'])
        || (raw && this.pickDirectFilePreviewString(raw, ['name', 'title', 'fileName', 'filename', 'resourceName', 'paperName', 'bookName']))
        || this.getDirectFilePreviewFileName(filePath)
        || 'Preview'
      const resourceType = this.getDirectFilePreviewResourceType(item)
      const numericResourceType = Number(resourceType)
      const isPdf = numericResourceType === 7
      const isImage = numericResourceType === 8 || numericResourceType === 9 || DIRECT_FILE_PREVIEW_IMAGE_EXTENSIONS.includes(extension)
      return {
        name,
        resourceType,
        filePath,
        resourceUrl: isPdf ? previewUrl : '',
        pdfPreviewUrl: isPdf ? previewUrl : '',
        imagePages: isPdf
          ? [{ pageNo: 1, imageUrl: '', pdfPreviewUrl: previewUrl, isPdfPreview: true }]
          : (isImage ? [{ pageNo: 1, imageUrl: previewUrl }] : []),
        recordings: [],
        // Keep direct previews compatible with the existing detail payload resolver.
        meta: { isDirectFilePreview: true },
        isDirectFilePreview: true
      }
    },
    pickDirectFilePreviewPath(item) {
      const sources = this.getDirectFilePreviewSourceChain(item)
      const keyGroups = [
        DIRECT_FILE_PREVIEW_FILE_PATH_KEYS,
        DIRECT_FILE_PREVIEW_PREVIEW_PATH_KEYS,
        DIRECT_FILE_PREVIEW_PATH_KEYS,
        DIRECT_FILE_PREVIEW_GENERIC_PATH_KEYS
      ]
      for (let groupIndex = 0; groupIndex < keyGroups.length; groupIndex += 1) {
        const keys = keyGroups[groupIndex]
        for (let sourceIndex = 0; sourceIndex < sources.length; sourceIndex += 1) {
          const path = this.pickDirectFilePreviewString(sources[sourceIndex], keys)
          if (path) {
            return path
          }
        }
      }
      return ''
    },
    pickDirectFilePreviewValue(source, keys) {
      if (!source || typeof source != 'object') {
        return undefined
      }
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i]
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          const value = source[key]
          if (value !== undefined && value !== null && (typeof value != 'string' || value.trim() !== '')) {
            return value
          }
        }
      }
      const sourceKeys = Object.keys(source)
      for (let i = 0; i < keys.length; i += 1) {
        const normalized = String(keys[i]).toLowerCase().replace(/[\s_\-/.]/g, '')
        for (let j = 0; j < sourceKeys.length; j += 1) {
          const sourceKey = sourceKeys[j]
          if (String(sourceKey).toLowerCase().replace(/[\s_\-/.]/g, '') != normalized) {
            continue
          }
          const value = source[sourceKey]
          if (value !== undefined && value !== null && (typeof value != 'string' || value.trim() !== '')) {
            return value
          }
        }
      }
      return undefined
    },
    getDirectFilePreviewOwnValue(source, keys) {
      if (!source || typeof source != 'object') {
        return { found: false, value: undefined }
      }
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i]
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          return { found: true, value: source[key] }
        }
      }
      const sourceKeys = Object.keys(source)
      for (let i = 0; i < keys.length; i += 1) {
        const normalized = String(keys[i]).toLowerCase().replace(/[\s_\-/.]/g, '')
        for (let j = 0; j < sourceKeys.length; j += 1) {
          const sourceKey = sourceKeys[j]
          if (String(sourceKey).toLowerCase().replace(/[\s_\-/.]/g, '') == normalized) {
            return { found: true, value: source[sourceKey] }
          }
        }
      }
      return { found: false, value: undefined }
    },
    pickDirectFilePreviewString(source, keys) {
      if (!source || typeof source != 'object') {
        return ''
      }
      const value = this.pickDirectFilePreviewValue(source, keys)
      return value === undefined || value === null ? '' : String(value).trim()
    },
    getDirectFilePreviewExtension(filePath) {
      const cleanPath = String(filePath || '').split(/[?#]/)[0]
      const fileName = cleanPath.split(/[\\/]/).pop() || ''
      const dotIndex = fileName.lastIndexOf('.')
      if (dotIndex < 0 || dotIndex == fileName.length - 1) {
        return ''
      }
      return fileName.slice(dotIndex + 1).toLowerCase()
    },
    getDirectFilePreviewFileName(filePath) {
      const cleanPath = String(filePath || '').split(/[?#]/)[0]
      return cleanPath.split(/[\\/]/).pop() || ''
    },
    toDirectFilePreviewUrl(filePath) {
      const value = String(filePath || '').trim()
      if (!value) {
        return ''
      }
      if (/^(?:blob:|data:|https?:|file:)/i.test(value)) {
        return value
      }
      const normalized = value.replace(/\\/g, '/')
      const encoded = this.encodeDirectFilePreviewPath(normalized)
      if (/^[a-zA-Z]:\//.test(normalized)) {
        return `file:///${encoded}`
      }
      if (normalized.startsWith('//')) {
        return `file:${encoded}`
      }
      if (normalized.startsWith('/')) {
        return `file://${encoded}`
      }
      return encoded
    },
    encodeDirectFilePreviewPath(path) {
      return String(path || '').split('/').map((segment, index) => {
        if (index === 0 && /^[a-zA-Z]:$/.test(segment)) {
          return segment
        }
        return encodeURIComponent(segment)
      }).join('/')
    },
    isResourceCountFolderItem(item) {
      if (!item || typeof item != 'object') {
        return false
      }
      if (item.isFolder) {
        return true
      }
      const raw = item.raw && typeof item.raw == 'object' ? item.raw : item
      const folderFlag = this.pickDirectFilePreviewValue(raw, ['isFolder', 'folder', 'isDir', 'directory'])
      if (folderFlag !== undefined && folderFlag !== null && folderFlag !== '') {
        if (typeof folderFlag == 'boolean') {
          if (folderFlag) {
            return true
          }
        } else {
          const normalizedFlag = String(folderFlag).trim().toLowerCase()
          if (['true', '1', 'folder', 'dir', 'directory', 'yes'].includes(normalizedFlag)) {
            return true
          }
        }
      }
      const resourceType = Number(this.pickDirectFilePreviewValue(raw, ['resourceType', 'resource_type', 'resrouceType', 'resrouce_type', 'type']) || item.resourceType || item.resrouceType)
      return Number.isFinite(resourceType) && (resourceType === 0 || resourceType === 5)
    },
    getResourceCountValue(item) {
      if (!item || typeof item != 'object') {
        return null
      }
      const raw = item.raw && typeof item.raw == 'object' ? item.raw : item
      const value = this.pickDirectFilePreviewValue(raw, [
        'childSize',
        'child_size',
        'childrenSize',
        'childCount',
        'childrenCount',
        'pageCount',
        'pages',
        'pageNum',
        'imagePageCount',
        'totalPage'
      ])
      return value === undefined || value === null || value === '' ? null : value
    },
    joinResourceCountUnit(count, unit, language) {
      const text = count === undefined || count === null ? '' : String(count)
      if (!unit) {
        return text
      }
      return COMPACT_COUNT_UNIT_LANGUAGES.includes(String(language || '').trim().toLowerCase())
        ? `${text}${unit}`
        : `${text} ${unit}`
    },
    formatResourceCountLabel(item, options = {}) {
      const emptyText = options.emptyText === undefined ? '' : String(options.emptyText)
      if (!item || typeof item != 'object') {
        return emptyText
      }
      const isFolder = this.isResourceCountFolderItem(item)
      const rawCount = this.getResourceCountValue(item)
      if (rawCount === null) {
        if (isFolder && options.zeroWhenFolder !== false) {
          return this.joinResourceCountUnit(0, options.itemUnit || '', options.language)
        }
        return emptyText
      }
      const numericCount = Number(rawCount)
      const countText = Number.isFinite(numericCount)
        ? String(Math.max(0, numericCount))
        : String(rawCount)
      return this.joinResourceCountUnit(
        countText,
        isFolder ? (options.itemUnit || '') : (options.pageUnit || ''),
        options.language
      )
    }
  }
}
